import Vue from 'vue'
import App from './App.vue'
import router from './router'

Vue.config.productionTip = false

Vue.filter('percentage', x => {
  return parseFloat(x)*100
});

Vue.filter('numberFormat', x => {
  var parts = parseFloat(x).toFixed(2).toString().split(".")
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".")
  return parts.join(",")
});

new Vue({
  router,
  render: function (h) { return h(App) }
}).$mount('#app')
